import React from 'react';
import { useAuth } from '../hooks/useAuth';
import { useTheme } from '../hooks/useTheme';

const Navigation = ({ activeTab, setActiveTab }) => {
    const { user } = useAuth();
    const { darkMode } = useTheme();

    const ADMIN_EMAIL = 'emailjaspertan@gmail.com';
    const isAdmin = user && user.email === ADMIN_EMAIL;

    const tabs = [
        { id: 'dashboard', label: 'Dashboard', icon: '📊' },
        { id: 'add-workout', label: 'Add Workout', icon: '➕' },
        { id: 'workouts', label: 'Workouts', icon: '🎥' },
        { id: 'history', label: 'History', icon: '📋' },
        { id: 'leaderboard', label: 'Leaderboard', icon: '🏆' },
        { id: 'rewards', label: 'Rewards', icon: '🎁' },
        // Only show admin tab for admin user
        ...(isAdmin ? [{ id: 'admin', label: 'Admin', icon: '⚙️' }] : []),
    ];

    return (
        <nav className={`${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} shadow-sm border-b`}>
            <div className="max-w-7xl mx-auto px-4">
                <div className="flex space-x-8 overflow-x-auto">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`flex items-center gap-2 py-4 px-2 border-b-2 font-medium text-sm whitespace-nowrap ${activeTab === tab.id
                                ? 'border-blue-500 text-blue-600'
                                : darkMode
                                    ? 'border-transparent text-gray-400 hover:text-gray-200 hover:border-gray-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }`}
                        >
                            <span>{tab.icon}</span>
                            {tab.label}
                        </button>
                    ))}
                </div>
            </div>
        </nav>
    );
};

export default Navigation;